export class BillingData {
  billingType: string = '';
  manualRate: number = 0;
  manualFafRate: number = 0;
  manualChargeTotal: number = 0;
}
